import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { RobotInline, useRobotController } from '@/plugin/src';
export function RobotWrapperSpeaking() {
    const robot = useRobotController();
    useEffect(() => {
        robot.startSpeaking();
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx("div", { id: "robot-container" }), _jsx(RobotInline, {})] }));
}
